import instanceQuery from 'graphql/queries/salesLedger/SalesVatOnlyTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const SalesVatOnlyTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default SalesVatOnlyTransactions;
